import { render } from "./DetailsHeartComponentSnackbar.vue?vue&type=template&id=6596ecaf&scoped=true"
import script from "./DetailsHeartComponentSnackbar.vue?vue&type=script&lang=js"
export * from "./DetailsHeartComponentSnackbar.vue?vue&type=script&lang=js"

import "./DetailsHeartComponentSnackbar.vue?vue&type=style&index=0&id=6596ecaf&scoped=true&lang=css"

import exportComponent from "C:\\_TimetipCode\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6596ecaf"]])

export default __exports__